import React from 'react';
import { Outlet } from 'react-router-dom';

const MyProfilePage: React.FC = () => {
  return (
    <div className="flex-1 overflow-y-auto p-6">
      <Outlet />
    </div>
  );
};

export default MyProfilePage;
